<template>
	<div
		class="flex w-full flex-col rounded bg-gradient-to-b from-[#137ABA] to-[#1898B9] p-6"
	>
		<div class="flex-1">
			<h4 class="text-2xl text-white">Group subscription</h4>
			<p class="m-0 p-0 text-lg font-medium text-white">
				More people, lower price for everyone
			</p>
			<TickList
				:items="items"
				icon-color="text-white"
				class="mt-6 text-white"
			/>
		</div>
		<div class="flex justify-end">
			<CarbarLink
				:hover="false"
				text-color="text-white"
				underline-color="decoration-white"
				href="/partners/carsales/group-subscription?ref=listingpage"
				text="Find out more"
			/>
		</div>
	</div>
</template>

<script setup>
import TickList from '@/components/lists/TickList.vue'
import CarbarLink from '@/components/links/CarbarLink.vue'

const items = [
	{
		label: 'Price drops as your group grows',
	},
	{
		label: 'Discount unlocks automatically',
	},
	{
		label: 'Same low rate for everyone',
	},
]
</script>
